import type { ReactNode } from "react";

import { cx } from "class-variance-authority";

import { useBelowBreakpoint } from "../../hooks/useBelowBreakpoint";

import * as theme from "./Sidebar.css";

export interface SidebarProps {
    collapsed?: boolean;
    brand?: ReactNode;
    bottom?: ReactNode;
    navLabel?: string;
    children: ReactNode;
    className?: string;
}

export function Sidebar({
    collapsed = false,
    brand,
    bottom,
    navLabel,
    children,
    className,
}: SidebarProps) {
    const phone = useBelowBreakpoint("md");

    return (
        <div
            data-slot="sidebar"
            data-state={collapsed ? "collapsed" : "expanded"}
            className={cx(
                theme.root,
                collapsed && theme.collapsedRoot,
                phone && theme.phoneRoot,
                phone && collapsed && theme.phoneCollapsedRoot,
                className
            )}
        >
            {brand && !phone && (
                <div
                    className={cx(
                        theme.brandBar,
                        collapsed && theme.collapsedBrandBar
                    )}
                >
                    {brand}
                </div>
            )}
            <nav
                aria-label={navLabel}
                className={cx(
                    theme.navList,
                    collapsed && theme.collapsedNavList
                )}
            >
                {children}
            </nav>
            {bottom && (
                <div
                    className={cx(
                        theme.bottomSlot,
                        collapsed && theme.collapsedBottomSlot
                    )}
                >
                    {bottom}
                </div>
            )}
        </div>
    );
}
